import { Link } from "react-router-dom";

/**
 * CombinedWork brand mark.
 * The C is rendered as an open arc (a sales pipeline → mouth opens to receive deals).
 * The W is a zig-zag that interlocks into the C's mouth (a project timeline with milestones).
 *
 *  - Deep navy  #0A2540  → the C (the surrounding container; "Combined")
 *  - Electric azure #2A7BFF → the W (the active timeline; "Work")
 *
 * Pure SVG, flat vector, scales infinitely, ~1KB on the wire.
 */
export const LogoMark = ({ size = 32, className = "", color, "data-testid": dataTestId }) => {
  const cColor = color || "#0A2540";
  const wColor = color || "#2A7BFF";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid={dataTestId}
      role="img"
      aria-label="CombinedWork"
    >
      <path
        d="M40 12C36 7 30 4 24 4C13 4 4 13 4 24C4 35 13 44 24 44C30 44 36 41 40 36"
        stroke={cColor}
        strokeWidth="6"
        strokeLinecap="square"
        fill="none"
      />
      <path
        d="M16 18L22 30L27 22L32 30L38 18"
        stroke={wColor}
        strokeWidth="4"
        strokeLinejoin="miter"
        strokeLinecap="square"
        fill="none"
      />
      <circle cx="16" cy="18" r="2.2" fill={wColor} />
      <circle cx="38" cy="18" r="2.2" fill={wColor} />
    </svg>
  );
};

/**
 * Full wordmark = LogoMark + "CombinedWork" wordmark.
 * Wrapped in a <Link> to "/" so clicking anywhere on the brand returns to landing.
 */
export const BrandLogo = ({ size = 32, dark = false, to = "/", className = "" }) => (
  <Link to={to} className={`inline-flex items-center gap-2.5 group ${className}`} data-testid="brand-logo-link">
    <LogoMark size={size} data-testid="brand-logo-mark" />
    <span className={`font-display font-black tracking-tighter text-lg leading-none ${dark ? "text-white" : "text-[#0A2540]"} group-hover:text-[#2A7BFF] transition-colors`}>
      Combined<span className="text-[#2A7BFF]">Work</span>
    </span>
  </Link>
);

export default BrandLogo;
